import { Skeleton, Stack } from '@mui/material';

import { Alert, NotableMarkdown, Text } from 'common';

import { useSubflowVersionQuery } from '../../SubFlow/Shared/useSubflowVersion';
import { useSharedSubflowBlockFields } from '../../SubFlow/Shared/utils';

export function SkillV2Documentation() {
  const { flowIdFieldProps, specificVersionFlowDefinitionIdFieldProps, versionTargetFieldProps } =
    useSharedSubflowBlockFields({ fieldNamePrefix: 'config' });
  const flowDefinitionResult = useSubflowVersionQuery({
    flowId: flowIdFieldProps.value,
    target: versionTargetFieldProps.value,
    flowDefinitionId: specificVersionFlowDefinitionIdFieldProps.value,
  });
  const { data, isPending, isError, error } = flowDefinitionResult;

  if (isPending) {
    return (
      <>
        <Text variant="heading1">
          <Skeleton />
        </Text>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="60%" />
      </>
    );
  }
  if (isError) {
    return <Alert error={error} />;
  }

  return (
    <Stack gap={2}>
      <NotableMarkdown>{data?.documentationMarkdown ?? 'No content'}</NotableMarkdown>
    </Stack>
  );
}
